import React from 'react'

const Telescope = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 65 64" fill="none" {...props}>
    <g clipPath="url(#clip0_2682_717)">
      <path
        d="M57.5308 6.2439H59.2033V7.80487H57.5308V6.2439Z"
        fill="#1D1D1D"
      />
      <path
        d="M57.5308 7.80493H59.2033V9.36591H57.5308V7.80493Z"
        fill="#1D1D1D"
      />
      <path
        d="M57.5308 6.2439H59.2033V7.80487H57.5308V6.2439Z"
        fill="#1D1D1D"
      />
      <path
        d="M60.8757 6.2439H62.5482V7.80487H60.8757V6.2439Z"
        fill="#1D1D1D"
      />
      <path
        d="M2.33917 34.3416H4.01165V35.9025H2.33917V34.3416Z"
        fill="#1D1D1D"
      />
      <path
        d="M2.33917 40.5854H4.01165V42.1464H2.33917V40.5854Z"
        fill="#1D1D1D"
      />
      <path
        d="M0.666687 37.4634H2.33916V39.0244H0.666687L0.666687 37.4634Z"
        fill="#1D1D1D"
      />
      <path
        d="M5.68408 37.4634H7.35656V39.0244H5.68408V37.4634Z"
        fill="#1D1D1D"
      />
      <path
        d="M14.0465 49.9512H15.719V51.5121H14.0465V49.9512Z"
        fill="#1D1D1D"
      />
      <path
        d="M14.0465 51.5122H15.719V53.0732H14.0465V51.5122Z"
        fill="#1D1D1D"
      />
      <path
        d="M14.0465 49.9512H15.719V51.5121H14.0465V49.9512Z"
        fill="#1D1D1D"
      />
      <path
        d="M19.0639 49.9512H20.7364V51.5121H19.0639V49.9512Z"
        fill="#1D1D1D"
      />
      <path
        d="M55.85 43.2149C55.4241 42.8131 54.7576 42.8131 54.3317 43.2149L53.5366 44.008L44.4553 34.884L45.2179 34.1234C45.6338 33.7059 45.6338 33.0316 45.2179 32.6136L40.255 27.5827L40.6704 27.1929C41.1026 26.7875 41.1235 26.1101 40.7176 25.679L16.9004 0.338467C16.7048 0.130783 16.4342 0.00889322 16.1483 0C16.1347 0 16.1216 0.00680082 16.1074 0.00680082C15.8363 -0.000523099 15.573 0.102011 15.3785 0.290338L2.67847 12.2151C2.45348 12.4254 2.33024 12.7221 2.33968 13.0297C2.34964 13.3373 2.49124 13.626 2.72882 13.8222L29.0843 35.6536V44.5138C27.0909 45.6579 25.8627 47.7777 25.8627 50.0721C25.8627 52.3661 27.0909 54.4858 29.0843 55.6304V62.9286C29.0843 63.5203 29.5653 64 30.1584 64H34.4547C35.0478 64 35.5287 63.5203 35.5287 62.9286V55.6304C37.5222 54.4858 38.7509 52.3661 38.7509 50.0721C38.7509 47.7777 37.5222 45.6579 35.5287 44.5138V41.1056L36.0904 41.6853C36.2918 41.8898 36.5671 42.006 36.8545 42.0065H36.8629C37.1477 42.0065 37.4209 41.8935 37.6223 41.6926L38.3954 40.9205L47.6765 49.8576L46.7377 50.7941C46.3187 51.2126 46.3187 51.8905 46.7377 52.309L49.7753 55.339C50.1949 55.757 50.8746 55.757 51.2941 55.339L58.8886 47.7641C59.3082 47.3461 59.3082 46.6676 58.8886 46.2491L55.85 43.2149ZM30.3614 33.9262L8.9241 16.1674L19.5415 6.28177L38.4158 26.3643L30.3614 33.9262ZM16.0702 2.58741L18.072 4.71865L7.25846 14.7895L5.03533 12.9486L16.0702 2.58741ZM33.3806 61.8573H31.2325V56.4036C31.9431 56.5323 32.6705 56.5323 33.3806 56.4036V61.8573ZM32.3065 54.3576C29.9339 54.3576 28.0103 52.4388 28.0103 50.0721C28.0103 47.705 29.9339 45.7866 32.3065 45.7866C34.6797 45.7866 36.6028 47.705 36.6028 50.0721C36.6028 52.4388 34.6797 54.3576 32.3065 54.3576ZM33.3806 43.7401C32.6705 43.6114 31.9431 43.6114 31.2325 43.7401V36.6799L33.3806 38.8923V43.7401ZM32.4765 34.883L38.689 29.0516L42.9402 33.3586L36.8713 39.4128L32.4765 34.883ZM39.9152 39.4117L42.9402 36.3969L52.022 45.5209L49.1953 48.3364L39.9152 39.4117ZM50.5347 53.0613L49.0159 51.5463L55.0911 45.4853L56.6104 47.0013L50.5347 53.0613Z"
        fill="#1D1D1D"
      />
      <path
        d="M39.1336 9.36591C40.9809 9.36591 42.4785 7.61873 42.4785 5.46347C42.4785 3.30822 40.9809 1.56104 39.1336 1.56104C37.2862 1.56104 35.7886 3.30822 35.7886 5.46347C35.7886 7.61873 37.2862 9.36591 39.1336 9.36591Z"
        fill="#FEC077"
      />
      <path
        d="M52.5134 24.9755C54.3608 24.9755 55.8584 23.2284 55.8584 21.0731C55.8584 18.9178 54.3608 17.1707 52.5134 17.1707C50.666 17.1707 49.1685 18.9178 49.1685 21.0731C49.1685 23.2284 50.666 24.9755 52.5134 24.9755Z"
        fill="#FEC077"
      />
      <path
        d="M57.5159 20.3186C57.4515 19.8957 57.1728 19.5559 56.8053 19.4516L53.407 18.4889L51.6978 14.5998C51.518 14.2584 51.1926 14.0488 50.842 14.0488C50.4909 14.0488 50.166 14.2584 49.9862 14.5998L48.2719 18.49L44.8735 19.4527C44.5075 19.5575 44.2297 19.8962 44.1653 20.3181C44.1004 20.7399 44.2605 21.1654 44.5742 21.4036L46.8824 23.1481L46.0897 26.7434C45.9973 27.1536 46.1238 27.5876 46.4142 27.8539C46.7046 28.1206 47.1051 28.1709 47.4399 27.9835L50.8369 26.0517L54.2343 27.9835C54.5681 28.1725 54.9687 28.1238 55.26 27.8592C55.5509 27.5945 55.6797 27.1616 55.5891 26.7509L54.7964 23.1555L57.1046 21.4115C57.4211 21.1723 57.5827 20.7431 57.5159 20.3186ZM53.1749 21.7704C52.8388 22.0244 52.6801 22.4902 52.7781 22.9343L53.23 24.9841L51.2645 23.87C50.9951 23.7176 50.6786 23.7176 50.4097 23.87L48.4465 24.9841L48.8989 22.9343C48.9969 22.4902 48.8377 22.0244 48.502 21.7704L47.432 20.9617L49.1589 20.4716C49.4302 20.3953 49.6585 20.1879 49.7831 19.9047L50.8369 17.5082L51.8887 19.9047C52.0138 20.1879 52.2421 20.3953 52.5129 20.4716L54.2399 20.9617L53.1749 21.7704Z"
        fill="#1D1D1D"
      />
      <path
        d="M45.1011 5.40346L41.7032 4.44079L39.9943 0.550931C39.8145 0.209576 39.4892 0 39.1386 0C38.7876 0 38.4627 0.209576 38.283 0.550931L36.5637 4.44079L33.1664 5.40346C32.7999 5.50825 32.5226 5.84696 32.4577 6.26876C32.3933 6.69056 32.5534 7.11606 32.8671 7.35422L35.175 9.09857L34.3824 12.6936C34.2885 13.1054 34.4155 13.5415 34.7073 13.8082C34.999 14.0755 35.4019 14.1242 35.737 13.9336L39.1335 12.0019L42.5304 13.9336C42.8642 14.1226 43.2647 14.0739 43.556 13.8093C43.8468 13.5446 43.9756 13.1117 43.8851 12.7011L43.0924 9.10598L45.4003 7.36215C45.7135 7.12347 45.8741 6.69797 45.8092 6.27617C45.7448 5.8549 45.4671 5.51566 45.1011 5.41087V5.40346ZM41.4684 7.72097C41.1323 7.97501 40.9736 8.44073 41.0716 8.88476L41.5235 10.9345L39.5583 9.82044C39.2889 9.66802 38.9724 9.66802 38.7036 9.82044L36.7435 10.9345L37.1958 8.88476C37.2938 8.44073 37.1346 7.97501 36.799 7.72097L35.7291 6.91231L37.4558 6.42224C37.727 6.34603 37.9553 6.13857 38.0799 5.85543L39.1335 3.45906L40.1852 5.85543C40.3103 6.13857 40.5386 6.34603 40.8093 6.42224L42.536 6.91231L41.4684 7.72097Z"
        fill="#1D1D1D"
      />
    </g>
    <defs>
      <clipPath id="clip0_2682_717">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0.666687)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default Telescope
